var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCareInfo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M15 12H9v2h6zM9 17h14v2H9zM19 22H9v2h10z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M7.735 2.507A3 3 0 0 1 10.695 0h10.61a3 3 0 0 1 2.96 2.507l.082.493H26a3 3 0 0 1 3 3v23a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h1.653zM21.639 8a3 3 0 0 0 3-3H26a1 1 0 0 1 1 1v23a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h1.36a3 3 0 0 0 3 3zM10.694 2a1 1 0 0 0-.986.836l-.334 2A1 1 0 0 0 10.361 6h11.278a1 1 0 0 0 .986-1.164l-.333-2A1 1 0 0 0 21.306 2z",
  clipRule: "evenodd"
})));
export default SvgCareInfo;